import React, { Component } from 'react';
import { Link } from 'react-router';
import axios from 'axios';
import moment from 'moment';
import appConfig from '../../../config.js';
import { DateStartEndField } from '../../commons/Inputs';

let chart;
let $ = window.jQuery;

export default class Index extends Component {

    state = {
        generalInfo: {
            "total_patients": 0,
            "patients_added": 0,
            "sales": 0,
            "patients_male": 0,
            "patients_female": 0,
            "average_age": 0
        },
        graphData: [
            {added:   []},
            {revenue: []}
        ],
        procedureSummary: [
            {"No procedures": 0}
        ],
        patientBalances: [],
        clinicActivity: [],
        filters: [
            {value : 'today', label : 'Today'},
            {value : 'last_week', label : 'Last week'},
            {value : 'last_month', label : 'Last month'},
            // {value : 'other', label : 'Other'}
        ],
        startDate: '',
        endDate: '',
    };

    componentDidMount() {
        let startDate = moment().subtract(30, 'days').format('MMM DD, YYYY');
        let endDate = moment().format('MMM DD, YYYY');

        this.setState({
            startDate,
            endDate
        }, ()=>{
            this.getGeneralInfo();
            this.getGraphData();
            this.getProcedureSummary();
            this.getPatientsWithBalance();
            this.getClinicActivity();
        });

        let options = {
            chart: {
                type: 'line'
            },
            title: {
                text: 'Monthly Added Patients'
            },
            xAxis: {
                type: 'datetime',
                dateTimeLabelFormats: { // don't display the dummy year
                    month: '%e. %b',
                    year: '%b'
                },
                // categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
            },
            yAxis: {
                title: {
                    text: '# of patients'
                }
            },
            plotOptions: {
                line: {
                    dataLabels: {
                        enabled: true
                    },
                    enableMouseTracking: true
                }
            },
            series: [{
                name: 'Patients',
                data: this.state.graphData.added
            }]
        };
        $('#graphContainer').highcharts({
            ...options
        });
        chart = $('#graphContainer').highcharts();
    }

    updateGraph = (filter) => {
        // eslint-disable-next-line
        switch(filter) {
            case "patients":
                chart.setTitle({
                    text: 'Monthly Added Patients'
                });
                chart.yAxis[0].setTitle({
                    text: '# of patients'
                });
                chart.series[0].update({
                    name:"Added Patients",
                    data:this.state.graphData.added
                }, false);
                chart.redraw();
                break;
            case "revenue":
                chart.setTitle({
                    text: 'Monthly Revenue'
                });
                chart.yAxis[0].setTitle({
                    text: 'Revenue'
                });
                chart.series[0].update({
                    name:"Revenue",
                    data:this.state.graphData.revenue
                }, false);
                chart.redraw();
                break;
        }
    }

    getGeneralInfo = () => {
        let startDate = moment(this.state.startDate, 'MMM DD, YYYY').format('YYYY-MM-DD')
        let endDate = moment(this.state.endDate, 'MMM DD, YYYY').format('YYYY-MM-DD')

        let url = appConfig.apiUrl + 'management/dental/dashboard/general?start_date='+startDate+'&end_date='+endDate;
        axios({
            url: url,
            timeout: 20000,
            method: 'get'
        }).then((res) => {
            let generalInfo = res.data.data;

            this.setState({
                generalInfo
            });
        }).catch((res) => {
            // display error
        });
    }

    getGraphData = () => {
        let startDate = moment(this.state.startDate, 'MMM DD, YYYY').format('YYYY-MM-DD')
        let endDate = moment(this.state.endDate, 'MMM DD, YYYY').format('YYYY-MM-DD')

        let url = appConfig.apiUrl + 'management/dental/dashboard/graphs?start_date='+startDate+'&end_date='+endDate;
        axios({
            url: url,
            timeout: 20000,
            method: 'get'
        }).then((res) => {
            let data = res.data.data;

            let added = data.added;
            Object.keys(added).forEach(function(key) {
                added[key] = [Date.parse(added[key][0]), added[key][1]]
            });

            let revenue = data.revenue;
            Object.keys(revenue).forEach(function(key) {
                revenue[key] = [Date.parse(revenue[key][0]), revenue[key][1]]
            });

            let graphData = {
                added,
                revenue
            };

            this.setState({
                graphData
            }, () => {
                this.updateGraph($("#graph_filter").val());
            });
        }).catch((res) => {
            // display error
        });
    }

    getProcedureSummary = () => {
        let startDate = moment(this.state.startDate, 'MMM DD, YYYY').format('YYYY-MM-DD')
        let endDate = moment(this.state.endDate, 'MMM DD, YYYY').format('YYYY-MM-DD')

        let url = appConfig.apiUrl + 'management/dental/dashboard/procedures?start_date='+startDate+'&end_date='+endDate;
        axios({
            url: url,
            timeout: 20000,
            method: 'get'
        }).then((res) => {
            let procedureSummary = res.data.data;

            this.setState({
                procedureSummary
            });
        }).catch((res) => {
            // display error
        });
    }

    getPatientsWithBalance = () => {
        let url = appConfig.apiUrl + 'management/dental/dashboard/balances';
        axios({
            url: url,
            timeout: 20000,
            method: 'get'
        }).then((res) => {
            let patientBalances = res.data.data;

            this.setState({
                patientBalances
            });
        }).catch((res) => {
            // display error
        });
    }

    getClinicActivity = () => {
        let startDate = moment(this.state.startDate, 'MMM DD, YYYY').format('YYYY-MM-DD')
        let endDate = moment(this.state.endDate, 'MMM DD, YYYY').format('YYYY-MM-DD')

        let url = appConfig.apiUrl + 'management/dental/dashboard/clinics?start_date='+startDate+'&end_date='+endDate;
        axios({
            url: url,
            timeout: 20000,
            method: 'get'
        }).then((res) => {
            let clinicActivity = res.data.data;

            this.setState({
                clinicActivity
            },()=>{
                $( "#clinicActivity" ).accordion({
                    collapsible: true,
                    animation: 200
                });
            });
        }).catch((res) => {
            // display error
        });
    }

    handleDateChange = (startDate, endDate) => {
        this.setState({startDate, endDate});
    }

    handleFilterDate = () => {
        this.getGeneralInfo();
        this.getGraphData();
        this.getProcedureSummary();
        this.getPatientsWithBalance();
        this.getClinicActivity();
    }

    render() {
        return(
            <div className="page-content">

                <div className="row">
                    <div className="col-md-8">
                        <h3 className="page-title">
                            Management &nbsp; <small>Dashboard</small>
                        </h3>
                    </div>
                    <div className="col-md-3">
                        <DateStartEndField start_id="start_date"
                                           end_id="end_date"
                                           startDate={this.state.startDate}
                                           endDate={this.state.endDate}
                                           onChange={this.handleDateChange} />
                    </div>
                    <div className="col-md-1">
                        <button type="submit" className="btn blue-sharp"
                                style={{width: '100%'}}
                                onClick={this.handleFilterDate}>
                            Filter
                        </button>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div className="dashboard-stat dashboard-stat-v2 blue" href="#">
                            <div className="visual">
                                <i className="icon-users"></i>
                            </div>
                            <div className="details">
                                <div className="number">
                                    <span data-counter="counterup" >{this.state.generalInfo.total_patients}</span>
                                </div>
                                <div className="desc"> Total Patients </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div className="dashboard-stat dashboard-stat-v2 blue" href="#">
                            <div className="visual">
                                <i className="icon-user"></i>
                            </div>
                            <div className="details">
                                <div className="number">
                                    <span data-counter="counterup" >{this.state.generalInfo.patients_male}</span>
                                </div>
                                <div className="desc"> Male patients </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div className="dashboard-stat dashboard-stat-v2 blue" href="#">
                            <div className="visual">
                                <i className="icon-user-female"></i>
                            </div>
                            <div className="details">
                                <div className="number">
                                    <span data-counter="counterup" >{this.state.generalInfo.patients_female}</span>
                                </div>
                                <div className="desc"> Female patients </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div className="dashboard-stat dashboard-stat-v2 blue" href="#">
                            <div className="visual">
                                <i className="icon-clock"></i>
                            </div>
                            <div className="details">
                                <div className="number">
                                    <span data-counter="counterup">{this.state.generalInfo.average_age.toFixed(0)}</span>
                                </div>
                                <div className="desc"> Average age of patient </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                        <div className="portlet light portlet-fit">
                            <div className="portlet-title">
                                <div className="caption">
                                    <i className=" icon-bar-chart font-blue" />
                                    <span className="caption-subject font-blue sbold uppercase">Clinic Overview</span>
                                </div>
                                <div className="actions">
                                    <select name="graph_filter" className="form-control" id="graph_filter" onChange={(e) => {this.updateGraph(e.target.value)}}>
                                        <option value="patients">Patients</option>
                                        <option value="revenue">Revenue</option>
                                    </select>
                                </div>
                            </div>
                            <div className="portlet-body">
                                <div className="row">
                                    <div className="col-md-12 col-sm-12">
                                        <div id="graphContainer" style={{ width: '100%' }}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-4 col-lg-4 col-sm-12 col-xs-12">
                        <div className="portlet light portlet-fit">
                            <div className="portlet-title">
                                <div className="caption">
                                    <i className=" icon-wallet font-blue" />
                                    <span className="caption-subject font-blue sbold uppercase">Patients with Balance</span>
                                </div>
                            </div>
                            <div className="portlet-body">
                                <div className="scroller" style={{ minHeight: '500px' }}>
                                    <div className="row">
                                        <div className="col-md-12 col-sm-12">
                                            <ul className="list-group list-special">
                                                {this.state.patientBalances.map((patient, i) => {
                                                    let phone = "";
                                                    if(patient.user.user_phone_numbers.length > 0) {
                                                        phone = "("+patient.user.user_phone_numbers[0].number+")";
                                                    }
                                                    return (
                                                        <li key={i} className="list-group-item">
                                                            <Link to={'/patients/'+patient.id} className="nav-link">
                                                                {patient.user.firstname + ' ' + patient.user.lastname + ' ' + phone}
                                                            </Link>

                                                            <span className="badge badge-info"> ₱{parseFloat(patient.total_balance).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')} </span>
                                                        </li>
                                                    )
                                                })}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 col-lg-4 col-sm-12 col-xs-12">
                        <div className="portlet light portlet-fit">
                            <div className="portlet-title">
                                <div className="caption">
                                    <i className=" icon-list font-blue" />
                                    <span className="caption-subject font-blue sbold uppercase">Clinic Activity</span>
                                </div>
                            </div>
                            <div className="portlet-body">
                                <div className="scroller" style={{ minHeight: '500px' }}>
                                    <div className="row">
                                        <div className="col-md-12 col-sm-12">
                                            <div className="panel-group accordion scrollable" id="clinicActivity">
                                                {this.state.clinicActivity.map((clinic, i) => {
                                                    return (
                                                        <div key={i} className="panel panel-default">
                                                            <div className="panel-heading">
                                                                <h4 className="panel-title">
                                                                    <a className="accordion-toggle" data-toggle="collapse" data-parent="#clinicActivity" href={'#accordion'+i} aria-expanded="true"> {clinic.name} </a>
                                                                </h4>
                                                            </div>
                                                            <div id={'accordion'+i} className="panel-collapse collapse" aria-expanded="true">
                                                                <div className="panel-body">
                                                                    <ul className="list-group list-special">
                                                                        <li className="list-group-item"> Treatments done
                                                                            <span className="badge badge-info"> {clinic.treatments_done} </span>
                                                                        </li>
                                                                        <li className="list-group-item"> Revenue
                                                                            <span className="badge badge-info"> {clinic.revenue} </span>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 col-lg-4 col-sm-12 col-xs-12">
                        <div className="portlet light portlet-fit">
                            <div className="portlet-title">
                                <div className="caption">
                                    <i className=" icon-graph font-blue" />
                                    <span className="caption-subject font-blue sbold uppercase">Procedure Summary</span>
                                </div>
                            </div>
                            <div className="portlet-body">
                                <div className="scroller" style={{ minHeight: '500px' }}>
                                    <div className="row">
                                        <div className="col-md-12 col-sm-12">
                                            <ul className="list-group list-special">
                                                {this.state.procedureSummary.map((procedure, i) => {
                                                    return (
                                                        <li key={i} className="list-group-item"> {procedure.procedure}
                                                            <span className="badge badge-info"> {procedure.count} </span>
                                                        </li>
                                                    )
                                                })}
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/management/Index.js
 **/